import { render } from "./tab_languages.vue?vue&type=template&id=e6e54854"
import script from "./tab_languages.vue?vue&type=script&lang=js"
export * from "./tab_languages.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__